import React from 'react';
import './Toolbar.css';

interface ToolbarProps {
    children: React.ReactNode;
}

const Toolbar: React.FC<ToolbarProps> = ({ children }) => {
    return (
        <div className="toolbar">
            {children}
        </div>
    );
};

export default Toolbar;
